// extracted by mini-css-extract-plugin
module.exports = {"lightbox":"ImageWrapper_lightbox__eVARn","close-icon":"ImageWrapper_close-icon__iQtSd","show":"ImageWrapper_show__3YpNp","show_image":"ImageWrapper_show_image__2InBM"};